/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface LeadAssignmentSummary
 */
export interface LeadAssignmentSummary {
    /**
     * 
     * @type {string}
     * @memberof LeadAssignmentSummary
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadAssignmentSummary
     */
    user_id: string;
    /**
     * 
     * @type {string}
     * @memberof LeadAssignmentSummary
     */
    role: LeadAssignmentSummaryRoleEnum;
}


/**
 * @export
 */
export const LeadAssignmentSummaryRoleEnum = {
    Owner: 'OWNER',
    Liaison: 'LIAISON'
} as const;
export type LeadAssignmentSummaryRoleEnum = typeof LeadAssignmentSummaryRoleEnum[keyof typeof LeadAssignmentSummaryRoleEnum];


/**
 * Check if a given object implements the LeadAssignmentSummary interface.
 */
export function instanceOfLeadAssignmentSummary(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "user_id" in value;
    isInstance = isInstance && "role" in value;

    return isInstance;
}

export function LeadAssignmentSummaryFromJSON(json: any): LeadAssignmentSummary {
    return LeadAssignmentSummaryFromJSONTyped(json, false);
}

export function LeadAssignmentSummaryFromJSONTyped(json: any, ignoreDiscriminator: boolean): LeadAssignmentSummary {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'user_id': json['user_id'],
        'role': json['role'],
    };
}

export function LeadAssignmentSummaryToJSON(value?: LeadAssignmentSummary | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'user_id': value.user_id,
        'role': value.role,
    };
}

